// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1RUxO","row":"ProcedureTreatmentSummary_row__3H8wO"};